import { Link, useRouteError } from "react-router-dom";
import styles from "./Error.module.scss";
import errorGirl from "@/assets/UI/error-girl.png";

export default function ErrorPage() {
  const error = useRouteError();
  const status = error?.status || 404;
  const message =
    error?.statusText || error?.message || "Oops! Something went wrong.";

  return (
    <div className={styles.page}>
      <div className={styles.glassCard}>
        <img src={errorGirl} alt="Error Girl" className={styles.illustration} />

        <h1 className="nu-title is-mrs" data-glow="3">
          {status === 404 ? "Page Not Found" : "Something Broke!"}
        </h1>

        <p className="nu-subtitle is-mr" data-glow="2">
          {message}
        </p>

        <Link to="/" className="nu-btn is-mr">
          ⬅ Back to Home
        </Link>
      </div>
    </div>
  );
}
